import { Component, AfterViewInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { HeroComponent } from './components/hero/hero.component';
import { TestimonialsComponent } from './components/testimonials/testimonials.component';
import { HowItWorksComponent } from './components/how-it-works/how-it-works.component';
import { ServicesComponent } from './components/services/services.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { IntegrationsComponent } from './components/integrations/integrations.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { AboutComponent } from './components/about/about.component';
import { CtaBannerComponent } from './components/cta-banner/cta-banner.component';
import { FaqComponent } from './components/faq/faq.component';
import { ContactComponent } from './components/contact/contact.component';
import { FooterComponent } from './components/footer/footer.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    HeroComponent,
    TestimonialsComponent,
    HowItWorksComponent,
    ServicesComponent,
    PortfolioComponent,
    IntegrationsComponent,
    PricingComponent,
    AboutComponent,
    CtaBannerComponent,
    FaqComponent,
    ContactComponent,
    FooterComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements AfterViewInit {
  title = 'kotha-landing';
  showScrollTop = false;
  showScrollBottom = true;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const maxScroll = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    
    this.showScrollTop = scrollPosition > 300;
    this.showScrollBottom = scrollPosition < maxScroll - 100;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  scrollToBottom() {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
  }

  ngAfterViewInit() {
    this.initScrollAnimations();
    // Initial check for scroll position on load
    setTimeout(() => this.onWindowScroll(), 100);
  }

  private initScrollAnimations() {
    const reveals = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');

    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          observer.unobserve(entry.target); // Only animate once
        }
      });
    }, {
      root: null,
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px"
    });

    reveals.forEach(reveal => {
      revealObserver.observe(reveal);
    });
  }
}
